import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {addClass, removeClass, digitToRupeeNotation} from "../../../../utils/common";
import './style.scss'
export default class Input extends Component {

    static propTypes = {
        name: PropTypes.string,
        value: PropTypes.any,
        onChange: PropTypes.func,
        errorMessage: PropTypes.string,
    }

    constructor(props){
        super(props);
        this.state={
            errorMessage:''
        }
    }

    onChange=(event)=>{
        let {name, onChange, errorMessage,isNumeric, isAlpha, isAlphaNumeric, isName, isEmail, fromGoalJourney, min, max, formDataClass} = this.props;
        isNumeric?event.target.value =event.target.value.replace(/\D/g,''): false;
        formDataClass && formDataClass.includes('included') ? event.target.value = event.target.value.replace(/,/g, '') : false;
        isAlpha ? event.target.value = event.target.value.replace(/[^a-zA-Z ]/g, ''): false;
        isAlphaNumeric ? event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g, ''): false;
        let {value} = event.target,
            element = document.getElementsByName(name)[0];

        value ? addClass(element,'active'): removeClass(element,'active');
        onChange && onChange(name,value);
    };

    render(){
        let {name, value, errorMessage, placeHolder, required=false, labelName,label, InputType="text", iconName, disableField=false,isNumeric,
                maxValueDate="", blurChange,maxLength, isAlpha, isAlphaNumeric, autoFocus=false, inline, formDataClass, fromGoalJourney, unit, min, max, isReadOnly} = this.props;
            // element = document.getElementsByName(name)[0];
        return(
            <div className={'form-data ' + formDataClass}>
                {label&& <span>
                    {label} {required && <span className="asterick">*</span>}
                </span>}
                {autoFocus ? <input type={InputType} name={name}  value={(value && formDataClass && formDataClass.includes('included') ? digitToRupeeNotation(value) : value)} placeholder={placeHolder}
                    autoFocus
                    disabled={disableField} max={maxValueDate ? maxValueDate : max} tabIndex="0" role="menuitem" maxLength={maxLength}
                    className={value && value.length>0 ? errorMessage && errorMessage.length>0 && errorMessage!='empty input'?
                    'active error':'active':errorMessage=='empty input'  && required?'error': ''}
                    onBlur={(event)=>{
                    blurChange && blurChange(name,value)
                    event.target.value == '' && required?  addClass(event.target,'error'):false}}
                    onChange={this.onChange}
                    min={min}
                    readOnly={isReadOnly}
                    onPaste={(e)=>{
                        if(fromGoalJourney){
                            e.preventDefault()
                            return false;
                        }
                    }} 
                    onCopy={(e)=>{
                        if(fromGoalJourney){
                            e.preventDefault()
                            return false;
                        }
                    }}
                    // autoComplete={fromGoalJourney ? 'new-password' : ''}
                    autoComplete='off'
                    aria-autocomplete="none"
                    /> :
                    <input type={InputType} name={name}  value={(value && formDataClass && formDataClass.includes('included') ? digitToRupeeNotation(value) : value)} placeholder={placeHolder}
                    disabled={disableField} max={maxValueDate ? maxValueDate : max} tabIndex="0" role="menuitem" maxLength={maxLength}
                    className={value && value.length>0 ? errorMessage && errorMessage.length>0 && errorMessage!='empty input'?
                    'active error':'active':errorMessage=='empty input'  && required?'error': ''}
                    onBlur={(event)=>{
                    blurChange && blurChange(name,value)
                    event.target.value == '' && required?  addClass(event.target,'error'):false}}
                    onChange={this.onChange}
                    min={min}
                    readOnly={isReadOnly}
                    onPaste={(e)=>{
                        if(fromGoalJourney){
                            e.preventDefault()
                            return false;
                        }
                    }} 
                    onCopy={(e)=>{
                        if(fromGoalJourney){
                            e.preventDefault()
                            return false;
                        }
                    }}
                    // autoComplete={fromGoalJourney ? 'new-password' : ''}
                    autoComplete='off'
                    aria-autocomplete="none"
                    />}
                {!!fromGoalJourney && !!value && <span className="input-unit">{unit}</span>}
                {iconName && <span className="open-button"><i className={iconName}/></span>}
                {labelName&& <label className='inputLabel'>
                    {labelName} {required && <span className="asterick">*</span>}
                </label>}
                {errorMessage && errorMessage!='empty input' && <span className='error-message'>
                                                <span className="asterick">* </span>
                                                <span dangerouslySetInnerHTML={{ __html: errorMessage }} />
                                             </span>}
            </div>
        )
    }
}
